import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { CalendarIntegrationProvider } from "@common/ADAPT.Common.Model/organisation/organisation-detail";
import { Autobind } from "@common/lib/autobind.decorator/autobind.decorator";
import { BaseComponent } from "@common/ux/base.component/base.component";
import { EMPTY, Observable } from "rxjs";
import { OAuthService } from "../../../oauth/oauth.service";
import { ICalendarConnectComponent } from "../../calendar.interface";

@Component({
    selector: "adapt-connect-no-calendar-integration",
    templateUrl: "./connect-no-calendar-integration.component.html",
    styleUrls: ["../../calendar-integration.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class ConnectNoCalendarIntegrationComponent extends BaseComponent implements ICalendarConnectComponent {
    @Input() public showLogoutButton = false;
    @Input() public disabled = false;

    public isAuthed$: Observable<boolean>;

    public constructor(private oauthService: OAuthService) {
        super();

        this.isAuthed$ = oauthService.isAuthedWithProvider$(CalendarIntegrationProvider.None);
    }

    @Autobind
    public login() {
        if (this.disabled) {
            return EMPTY;
        }

        return this.oauthService.login(CalendarIntegrationProvider.None);
    }
}

